/* ARTEFOÁ DERMOCOSMÉTICOS — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ── MOBILE MENU ──────────────────────── */
  const toggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ── ANNOUNCEMENT SLIDER (if multiple) ───── */
  const msgs = document.querySelectorAll('.announcement-bar__msg');
  if (msgs.length > 1) {
    let idx = 0;
    msgs.forEach((m, i) => m.style.display = i === 0 ? 'flex' : 'none');
    setInterval(() => {
      msgs[idx].style.display = 'none';
      idx = (idx + 1) % msgs.length;
      msgs[idx].style.display = 'flex';
    }, 4000);
  }

  /* ── DINHEIRO ───────────────────────── */
  /* A API do carrinho devolve centavos. Formatar aqui, num lugar so. */
  function afMoney(centavos) {
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
  }

  /* ── CART DRAWER ────────────────────── */
  const cartBtns = document.querySelectorAll('[data-cart-open]');
  const cartDrawer = document.getElementById('cart-drawer');
  /* querySelectorAll, nao querySelector: existem DOIS elementos que fecham a
     gaveta — o X do cabecalho e o botao "Continuar comprando" do rodape.
     Com o singular, o segundo nunca receberia o ouvinte. */
  const cartCloses = document.querySelectorAll('[data-cart-close]');
  const cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
  cartBtns.forEach(b => b.addEventListener('click', openCart));
  cartCloses.forEach(b => b.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Esc fecha a gaveta — esperado em qualquer dialogo */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
      closeCart();
    }
  });

  /* ── ADD TO CART ────────────────────── */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const data = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: data });
      if (!res.ok) throw new Error('Cart add failed');
      await updateCart();
      openCart();
    } catch (err) {
      console.error(err);
    }
  });

  async function updateCart() {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const count = document.querySelectorAll('.cart-count__bubble');
    count.forEach(el => { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
      el.textContent = afMoney(cart.total_price);
    });
    const drawerItems = document.getElementById('cart-drawer-items');
    if (drawerItems) renderCartItems(cart, drawerItems);
  }

  function renderCartItems(cart, container) {
    if (cart.item_count === 0) {
      container.innerHTML = '<p style="padding:24px;color:#AFAFAF;font-size:13px;">Seu carrinho está vazio.</p>';
      return;
    }
    container.innerHTML = cart.items.map(item => {
      /* variant_title vem NULL em produto de variante unica — nao vem a string
         'Default Title'. A comparacao antiga so testava a string, entao o null
         passava e a gaveta imprimia a palavra "null" embaixo do nome. */
      const temVariante = item.variant_title && item.variant_title !== 'Default Title';
      return `
      <div class="cart-item">
        <img src="${item.image}" alt="${item.product_title}" class="cart-item__img">
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          ${temVariante ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${afMoney(item.final_line_price)}${item.quantity > 1 ? ` <span style="color:#AFAFAF;font-size:12px;">(${item.quantity}×)</span>` : ''}</div>
        </div>
        <button class="cart-item__remove" data-line="${item.key}" aria-label="Remover ${item.product_title}">×</button>
      </div>
    `;
    }).join('');
    container.querySelectorAll('[data-line]').forEach(btn => {
      btn.addEventListener('click', () => removeFromCart(btn.dataset.line));
    });
  }

  async function removeFromCart(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    updateCart();
  }

  updateCart();

  /* ── PRODUCT IMAGE GALLERY ─────────────── */
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.getElementById('product-main-image');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = this.dataset.src;
      thumbs.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

  /* ── STICKY HEADER SHADOW ──────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.borderBottomColor = window.scrollY > 10 ? '#D8D8D8' : '#D8D8D8';
    }, { passive: true });
  }

});
